import {
    TablePage,
    AddPage,
    EditPage,
    ViewPage,
  } from 'src/views/aceocean/permittotransfer'
  import pathMap from 'src/paths/pathMap'
  
  class AceOcnPermitToTransferRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.ACE_OCN_PERMIT_TO_TRANSFER_LIST_VIEW,
          component: TablePage
        },
        {
          exact: true,
          path: pathMap.ACE_OCN_PERMIT_TO_TRANSFER_ADD_VIEW,
          component: AddPage
        },
        {
          exact: true,
          path: pathMap.ACE_OCN_PERMIT_TO_TRANSFER_EDIT_VIEW,
          component: EditPage
        },
        {
          exact: true,
          path: pathMap.ACE_OCN_PERMIT_TO_TRANSFER_DETAILS_VIEW,
          component: ViewPage
        }
      ]
    }
  }
  
  export default AceOcnPermitToTransferRoute
  